export const PrivacySection2b = () => {
  return (
    <section id="data-deletion">
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Your Right to Data Deletion</h2>
      <div className="space-y-4 text-base leading-relaxed text-gray-700">
        <p className="font-semibold text-gray-900">
          You have the right to request deletion of your personal data at any time.
        </p>

        <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
          4.1 How to Request Data Deletion
        </h3>
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
          <p className="font-semibold text-gray-900 mb-4">
            To request deletion of your data, follow these steps:
          </p>
          <ol className="ml-6 space-y-3 list-decimal">
            <li>
              Send an email to:{' '}
              <a
                href="mailto:viprielt24@gmail.com?subject=Data%20Deletion%20Request%20-%20WinGrow"
                className="text-blue-600 underline hover:text-blue-800 font-semibold"
              >
                viprielt24@gmail.com
              </a>
            </li>
            <li>
              Use the subject line:{' '}
              <code className="bg-gray-100 px-2 py-1 rounded">
                "Data Deletion Request - WinGrow"
              </code>
            </li>
            <li>
              Include in your email:
              <ul className="ml-6 mt-2 space-y-1 list-disc">
                <li>Your full name</li>
                <li>Email address associated with your WinGrow account</li>
                <li>Facebook User ID (if you signed in with Facebook)</li>
                <li>Brief description of the data you want deleted</li>
              </ul>
            </li>
          </ol>
        </div>

        <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
          4.2 Data Deletion Timeline
        </h3>
        <ul className="ml-6 space-y-2 list-disc">
          <li>
            <strong>Confirmation:</strong> We will confirm receipt of your request within 2 business
            days
          </li>
          <li>
            <strong>Deletion:</strong> Your data will be permanently deleted within 30 days
          </li>
          <li>
            <strong>Final Confirmation:</strong> You will receive confirmation once deletion is
            complete
          </li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
          4.3 What Data Will Be Deleted
        </h3>
        <p>Upon your request, we will delete:</p>
        <ul className="ml-6 space-y-2 list-disc">
          <li>Your account information and profile data</li>
          <li>All conversation history and messages</li>
          <li>Lead contact information associated with your account</li>
          <li>Analytics and usage data linked to your account</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
          4.4 Data Retention for Legal Compliance
        </h3>
        <p>Some data may be retained for legal or security purposes, including:</p>
        <ul className="ml-6 space-y-2 list-disc">
          <li>Transaction records (required by law for 7 years)</li>
          <li>Security logs (retained for fraud prevention)</li>
          <li>Data needed to resolve disputes or enforce agreements</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
          4.5 Facebook Users: Additional Options
        </h3>
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
          <p className="mb-3">
            If you signed in to WinGrow using Facebook, you can also manage your data through
            Facebook:
          </p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>
              Visit Facebook's Data Deletion Instructions:{' '}
              <a
                href="https://www.facebook.com/help/contact/283496498718550"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800"
              >
                https://www.facebook.com/help/contact/283496498718550
              </a>
            </li>
            <li>Go to your Facebook Settings → Apps and Websites → Find "WinGrow" → Remove</li>
            <li>Review and manage app permissions in your Facebook account settings</li>
          </ul>
        </div>
      </div>
    </section>
  );
};
